import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/estoque')({
  component: EstoqueLayout,
});

function EstoqueLayout() {
  return <Outlet />;
}
